export interface BorrowerNameLike {
  firstName?: string | null;
  lastName?: string | null;
}

export const formatBorrower = (users: BorrowerNameLike[] | null | undefined): string => {
  if (!users || users.length === 0) return '—';
  const [first] = users;
  const name = [first?.firstName, first?.lastName].filter(Boolean).join(' ');
  const suffix = users.length > 1 ? ` +${users.length - 1}` : '';

  return name ? `${name}${suffix}` : '—';
};
